
// #region INITIAL_STATE
export const initialState = {
    data: {
        serviceRow: null,          // the full row returned from tbl_services_test
        tabsData: [],              // parsed from config.tabs_data (json)
        faqData: [],               // parsed from config.faq_data (json) OR from your faq thunk later
        serviceDetailsData: [],    // parsed from config.service_details_data (json)
        buttonsData: [],           // parsed from config.buttons (json)
        pageTitle: "",
        pageSubtitle: "",
    },

    loading: {
        isLoadingPage: false,
    },

    error: {
        hasError: false,
        message: "",
    },
};
// #endregion

// #region REDUCER
export function manageDynamicServiceReducer(state, action) {
    switch (action.type) {
        // #region LOADING
        case "SET_LOADING":
            return {
                ...state,
                loading: {
                    ...state.loading,
                    [action.payload.key]: action.payload.value,
                },
            };
        // #endregion

        // #region ERROR
        case "SET_ERROR":
            return {
                ...state,
                error: {
                    hasError: true,
                    message: action.payload || "Something went wrong",
                },
            };

        case "CLEAR_ERROR":
            return {
                ...state,
                error: {
                    hasError: false,
                    message: "",
                },
            };
        // #endregion

        // #region DATA
        case "SET_SERVICE_ROW":
            return {
                ...state,
                data: {
                    ...state.data,
                    serviceRow: action.payload || null,
                },
            };

        case "SET_PAGE_META":
            return {
                ...state,
                data: {
                    ...state.data,
                    pageTitle: action.payload?.pageTitle ?? "",
                    pageSubtitle: action.payload?.pageSubtitle ?? "",
                },
            };

        case "SET_TABS_DATA":
            return {
                ...state,
                data: {
                    ...state.data,
                    tabsData: action.payload || [],
                },
            };

        case "SET_FAQ_DATA":
            return {
                ...state,
                data: {
                    ...state.data,
                    faqData: action.payload || [],
                },
            };

        case "SET_SERVICE_DETAILS_DATA":
            return {
                ...state,
                data: {
                    ...state.data,
                    serviceDetailsData: action.payload || [],
                },
            };

        case "SET_BUTTONS_DATA":
            return {
                ...state,
                data: {
                    ...state.data,
                    buttonsData: action.payload || [],
                },
            };

        case "RESET_PAGE":
            return initialState;
        // #endregion

        default:
            return state;
    }
}
// #endregion
